import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter, of, switchMap, take } from 'rxjs';
import { chatsFeature, ChatsState } from './store';
import { ChatsActions } from './store/chats.actions';

export const chatsResolver = () => {
  const chatsStore = inject<Store<ChatsState>>(Store);

  if (chatsStore.selectSignal(chatsFeature.selectLoaded)()) {
    return of(chatsStore.selectSignal(chatsFeature.selectAll)());
  }

  chatsStore.dispatch(ChatsActions.loadChats());

  return chatsStore.select(chatsFeature.selectLoaded).pipe(
    filter((loaded) => loaded),
    take(1),
    switchMap(() => chatsStore.select(chatsFeature.selectAll)),
  );
};
